export default __webpack_public_path__ + "static/media/split_view.a498f887.svg";